<template>
  <div class="content">
    <div class="content-box">
      <img class="imgStyle" src="@/assets/images/successfulPop.png" alt="" />
      <div class="textStyle">You have completed the commission settings</div>
      <artmisads-button type="primary" @click="handleClick">
        {{ props.type === 'single' ? 'Back to publishers' : 'Ok' }}
      </artmisads-button>
    </div>
  </div>
</template>
<script setup>
import { ref,defineEmits } from 'vue'
import { useRouter } from 'vue-router'
const emit = defineEmits(['confirm'])
const router = useRouter()
const props = defineProps({
  type: {
    type: String,
    default: 'single',
  },
  isAcc: {
    type: String,
    default: 'true',
  },
})
const handleClick = () => {
  emit('confirm')
  if(props.isAcc=='true'){
    router.push({
      path: '/seller/associateCentral/publishers',
    })
  }else{
    router.push({
      path: '/seller/publishers',
    })
  }
  
}
</script>
<style scoped lang="less">
.content {
  padding: 16px;
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  // max-height: 570px;
  min-height: 600px;
  .content-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .imgStyle {
    width: 216px;
  }
  .textStyle {
    font-family: Sora;
    font-weight: 500;
    font-style: Medium;
    font-size: 16px;
    color: rgba(15, 6, 41, 1);
    margin-bottom: 16px;
  }
}
</style>
